<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Create new team</h1>
        </template>
        
        <div v-if="true">
            <div class="my-4 w-full">
                <label for="name" class="font-bold">Team Name</label>
                <input type="text" name="name" id="name" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full" placeholder="Your team name" v-model="name">
                <p class="text-destructive" v-if="errors.name && errors.name.length > 0">{{ errors.name[0] }}</p>
            </div>

            <div class="my-4 w-full">
                <label for="email" class="font-bold">Team Email Address</label>
                <input type="text" name="email" id="email" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full" placeholder="billing@example.com" v-model="email">
                <p class="text-sm text-gray-darker">This email address will be used for important notifications and billing purposes.</p>
                <p class="text-destructive" v-if="errors.email && errors.email.length > 0">{{ errors.email[0] }}</p>
            </div>

            <div class="my-4 w-full">
                <label for="profile" class="font-bold">Billing Details</label>
                <textarea name="profile" id="profile" rows="5" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full" v-model="profile"></textarea>
                <p class="text-sm text-gray-darker">This information will be reflected on the invoices. Use it for tax information, billing address, etc.</p>
                <p class="text-destructive" v-if="errors.profile && errors.profile.length > 0">{{ errors.profile[0] }}</p>
            </div>

            <div class="mt-4 w-full">
                <p class="text-destructive" v-if="errors.general && errors.general.length > 0">{{ errors.general[0] }}</p>
            </div>
        </div>
        <div v-else>
            <loading />
        </div>

        <template v-slot:footer v-if="loaded">
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Updating..."
                @click.native="update"
            >
                Update
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        team: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            loaded : true,
            name   : this.team.name,
            email  : this.team.email,
            profile: this.team.profile,
            loading: false,
            errors : {},
        }
    },
    methods: {
        update() {
            this.errors = {};
            this.loading = true;
            
            axios.put(`/api/teams/${this.team.id}`, {
                name   : this.name,
                email  : this.email,
                profile: this.profile,
            })
            .then(response => {
                this.$emit('resolve', response);
            })
            .catch(err => {
                this.errors = err.response.data.errors;
                this.loading = false;
                console.error(err);
            }).then(() => {
                this.loading = false;
            });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>